<section *ngIf="!loggingIn" class="welcome-panel" aria-labelledby="welcome-title">
  <div class="welcome-intro">
    <p class="portal-eyebrow">Health Facility Licensing &amp; Certification</p>
    <h1 id="welcome-title">Health Licensing Portal</h1>
    <p class="welcome-description">Apply for and manage your health facility licenses and certifications with the Oregon Health Authority.</p>
  </div>
  <div class="welcome-access">
    <mat-icon class="access-icon" aria-hidden="true">account_circle</mat-icon>
    <h2>Welcome to the licensing portal</h2>
    <p>Sign in to access your applications, manage licenses, and view payments.</p>
    <button mat-flat-button color="primary" (click)="login()">Sign in or create an account <mat-icon iconPositionEnd>arrow_forward</mat-icon></button>
    <p class="access-note">New to the portal? You can create an account when you sign in.</p>
    <a routerLink="/accessibility-notice">Accessibility and assistance</a>
  </div>
</section>
<div *ngIf="loggingIn" class="portal-loading" role="status">
  <p>Loading your licensing portal…</p>
  <mat-progress-bar mode="indeterminate" aria-label="Loading your licensing portal"></mat-progress-bar>
</div>
